module.exports = __webpack_public_path__ + "img/BTC-logo.e42a01bf.png";